import { theme } from '@/styles/theme';
import { usePathname } from 'next/navigation';
import * as S from './styles';
import Breadcrumbs from '@/components/molecules/Breadcrumbs';
import { BreadcrumbPaginaProps } from '../..';

export default function BreadcrumbsPaginaDesktop(props: BreadcrumbPaginaProps) {
  const { $nomePaginaAtual } = props;
  const caminhoURL = usePathname();

  return (
    <S.Container>
      <Breadcrumbs
        links={[
          {
            atual: true,
            href: caminhoURL,
            texto: $nomePaginaAtual,
          },
        ]}
        style={{
          maxWidth: 1280,
          margin: '0 auto',
          padding: `${theme.spacing[2]}px ${theme.spacing[6]}px`,
        }}
      />
    </S.Container>
  );
}
